<template>
  <div :resp='resp' class='h-mml-resp-table'>
    <table class='h-mml-resp-tableBordered'>
      <thead>
        <tr>
          <th :title='field.i18nkey' v-for='(field, index) in fields' :key='index'>{{field.i18nkey}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='(record,index) in resp.data.Data' :key='index'>
          <td :title='record[field.key]' v-for='(field,index) in fields' :key='index'><pre v-if="field.key == 'MessageContent'">
            {{record[field.key]}}</pre><span v-else>{{record[field.key]}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ShowData',
  props: {
    resp: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    fields() {
      return this.getFields().sort((a,b) => (a.attrId - b.attrId));
    }
  },
  methods: {
    getFields() {
      const records = this.resp.data.Data;
      const fields = [];
      const recordKeys = [];
      if (records && records.length > 0) {
        records.forEach((record) => {
          Object.keys(record).forEach(recordKey => {
            if (Object.hasOwnProperty.call(record, recordKey) && recordKeys.indexOf(recordKey) < 0) {
              if (this.resp.mo) {
                const attrInfo = this.resp.mo.attrMap[recordKey];
                if (attrInfo) {
                  const attrUnit = attrInfo.unit.trim();
                  const unit = attrUnit === null || attrUnit === 'NA' || attrUnit === '' ? '' : `(${attrUnit})`;
                  // TODO by s18857 判断当前语言环境 国际化
                  const i18nkey = this.LOCALE === 'zh'? attrInfo.zhName:attrInfo.enName;
                  const i18nkeyWithUnit = i18nkey + unit;
                  fields.push({
                    attrId: parseInt(attrInfo.id, 10),
                    key: recordKey,
                    i18nkey: i18nkeyWithUnit
                  });
                } else {
                  fields.push({ attrId: 0, key: recordKey, i18nkey: recordKey });
                }
              } else {
                fields.push({ attrId: 0, key: recordKey, i18nkey: recordKey });
              }
              recordKeys.push(recordKey);
            }
          });
        });
      } else {
        fields.push({
          i18nkey: this.$t('MML.noResult')
        });
      }
      return fields;
    }
  }
};
</script>

<style>

</style>